import '@app/App.css';
import UserButton from './UserButton';
import ManualButton from './ManualButton';

function AppHeaderNav() {

  return (
    <nav className='flex items-center gap-4'>
      <ManualButton />
      <UserButton />
    </nav>
  );

};

export default AppHeaderNav;